<template>
  <div id="app" style="position:relative;">
    <navbar-overlay v-if="$route.name !== 'survey'"></navbar-overlay>
    <!-- <top-section></top-section> -->
    <router-view class="page-wrapper" style="min-height:600px;">
    </router-view>
    <footer-main></footer-main>
  </div>
</template>

<script>
import NavbarFull from '@/components/NavBarFull.vue'
import NavbarOverlay from '@/components/NavBarOverlay.vue'
import TopSection from '@/components/TopSection.vue'
import FooterMain from '@/components/Footer.vue'

import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import EventBus from '@/controllers/EventBus'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'app',
  components: {
    NavbarFull,
    NavbarOverlay,
    TopSection,
    FooterMain,
    PulseLoader
  },
  data () {
    return {
    }
  },
  computed: mapGetters([
    'isAuthenticated'
  ]),
  methods: {
    sample (data) {

    },
    // http://redux.js.org/docs/recipes/UsingObjectSpreadOperator.html
    ...mapActions([
      'authenticated',
      'unauthenticated'
    ])
  },
  beforeCreate () {
    /* global window */
    window.onLoadCallback = function () {
      console.log('callback function here...')
    }
  },
  created () {
    // console.log('created App.vue')
    // EventBus.$off('authenticated')
    // EventBus.$on('authenticated', (data) => {
    //   this.authenticated(data)
    // })
    // EventBus.$off('unauthenticated')
    // EventBus.$on('unauthenticated', () => {
    //   this.unauthenticated()
    // })

    // on master event resize (propagating to EventBus)
    EventBus.isDesktop = (window.innerWidth >= 768)
    EventBus.windowWidth = (window.innerWidth)
    window.addEventListener('resize', function (event) {
      EventBus.isDesktop = (event.target.innerWidth >= 768)
      EventBus.windowWidth = (window.innerWidth)
    })
  },
  beforeMount () {
    // console.log('beforeMount App.vue')
    window.addEventListener('load', () => {
    })
  },
  mounted () {
  }
}
</script>

<style lang="scss">
@import "./styles/app_setting.scss";

html.modal-open {
  overflow: hidden;
  position: relative;
  height: 100%;
  body {
    overflow: hidden;
    position: relative;
    height: 100%;
  }
}

#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: $font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body, .page-wrapper {
  background-color: transparent;
}

</style>



// WEBPACK FOOTER //
// App.vue?0ecba306